<dx-error-page>
  <ng-container *dxErrorPageHeader>
    <dx-page-header [options]="headerOptions"></dx-page-header>
  </ng-container>
</dx-error-page>
